import { axiosAdapter } from "@inertiajs/core";
import { createInertiaApp } from "@inertiajs/react";
import fetchAdapter from "@shiroyasha9/axios-fetch-adapter";
import axios from "axios";

import { initI18n } from "@shared/i18n/initI18n";
import {
  inertiaDefaults,
  resolveDefaultLayout,
} from "./inertiaConfig";
import { hydrateRoot } from "react-dom/client";

axios.defaults.adapter = fetchAdapter;
const inertiaHttpClient = axiosAdapter(axios);

await initI18n()
createInertiaApp({
  http: inertiaHttpClient,
  pages: "../pages",
  layout: resolveDefaultLayout,
  strictMode: true,
  defaults: inertiaDefaults,
  setup({ el, App, props }) {
    if (el) {
      hydrateRoot(el, <App {...props} />)
    }
  },
}).catch((error) => {
  if (document.getElementById("app")) {
    throw error;
  }

  console.error(
    "Missing root element.\n\n" +
    "If you see this error, it probably means you loaded Inertia.js on non-Inertia pages.\n" +
    'Consider moving <%= vite_typescript_tag "inertia.tsx" %> to the Inertia-specific layout instead.'
  );
});
